<template>
    <div>

<!--
    :sort-field="['category', 'type', 'subType', 'variant', 'qty', 'agl', 'isBillable']"
 -->

    <xolas-table
      ref="assetTable"
      :table-ref="tableRef"

      :title="title"
      :title-heading="titleHeading"
      icon="fa fa-tools"


      :url="'/assets/site/' + (siteId ? siteId : '')
      + (this.ownerId ? '/owner/' + this.ownerId : '')
      + (this.filterCol && this.filterVal ? '/' + this.filterCol + '/' + this.filterVal : '')"

      :fields="fields"

      :hideTop="hideTop"

      :showSearch="showSearch"
      :showRefresh="showRefresh"

      :searchPlaceholder="searchPlaceholder"
      :layer-component="isTowerCo() ? 'equipDetail' : null"
      :layer-args="layerArgs"
      @total-changed="totalChanged">

      <template #shortName="props">
        <org-badge :organisation="props.rowData.organisation" />
      </template>

      <template #assets="props">
        <el-row :gutter="8" style="padding-right: 1em;">

          <el-col :xs="24" :sm="24" :md="12" :lg="14">
            <!-- eslint-disable-next-line vue/no-v-html -- formatter output, admin-curated catalogue fields. NOTE: if equipment category/type/subType ever become user-editable, this becomes Bug O — convert to v-safe-html. -->
            <span v-html="formatAssetName(props.rowData)" />
            <span class="text-primary" v-if="props.rowData.diameter">&nbsp;| Dia: <b>{{props.rowData.diameter}}</b> &deg;</span>
            <b class="text-success" v-if="props.rowData.agl">&nbsp;| AGL: <b>{{props.rowData.agl}}</b>m.</b>
            <span class="text-warning" v-if="props.rowData.installedOn">&nbsp;| Installed: {{formatDate(props.rowData.installedOn)}}</span>
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="10" :align="isDesktop ? 'right' : ''">
            <!-- eslint-disable vue/no-v-html -- formatter output, numeric → <b><sup> ordinal markup -->
            <span v-if="props.rowData.setNo"
            v-html="addSuffix(props.rowData.setNo, true, true, 'Set')">&nbsp;</span>
            <!-- eslint-enable vue/no-v-html -->
            {{formatBillable(props.rowData.isBillable)}}&nbsp;
          </el-col>
        </el-row>

      </template>

      <template #equip-controls="props">
        <equip-controls :row-data="props.rowData" :action-step-id="actionStepId" />
      </template>

      <!-- New-Equipment button — XolasTable has no add-action/add-props props
           (vuetable-2 legacy); render the action in the shared #actions slot
           like the other migrated tables (mirrors SitePermits.vue). -->
      <template v-if="!noAdd && isManager('project|maintenance|finance')" #actions>
        <equip-action
          :action-step-id="actionStepId"
          :site-id="Number(siteId)"
          :owner-id="ownerId ? Number(ownerId) : xolasClient().id"
          :read-only="readOnly" />
      </template>

    </xolas-table>

    <div v-if="isTowerCo() && !readOnly && showQrCode && isManager('project|maintenance') && totals > 0" class="bg-primary-lighten-1" style="padding: 0.2em;">
      <el-row>
        <el-col align="center">
          <el-button type="primary" round :icon="icon" @click="qrCodeActions" :disabled="!enabled">&nbsp;{{qrCodeBtn}}</el-button>
        </el-col>
      </el-row>
    </div>

  </div>
</template>


<script>

// import kjua from 'kjua'
// import JSZip from 'jszip'

import QrCodeMixins from '@/mixins/QrCodeMixins'
import SiteMixins from '@/mixins/SiteMixins'

import EquipControls from '@/components/assets/EquipControls'
import EquipAction from '@/components/actions/EquipAction'

const DEFAULT_ICON = 'fa fa-qrcode'
const DEFAULT_MSG = 'Download QR Codes for Site Equipment'

export default {
  mixins: [SiteMixins, QrCodeMixins],

  components: {
    EquipControls,
    EquipAction
  },

  props: {
    siteId: {
      type: [String, Number],
      required: true
    },

    ownerId: {
      type: Number,
      default: null
    },

    siteData: {
      type: Object,
      default: null
    },

    filterCol: {
      type: String,
      default: null
    },

    filterVal: {
      type: String,
      default: null
    },

    title: {
      type: String,
      default: ''
    },

    titleHeading: {
      type: String,
      default: 'h3'
    },

    tableRef: {
      type: String,
      default: 'equiptable'
    },

    noAdd: {
      type: Boolean,
      default: false
    },

    hideTop: {
      type: Boolean,
      default: false
    },

    showSearch: {
      type: Boolean,
      default: true
    },

    showQrCode: {
      type: Boolean,
      default: true
    },

    showRefresh: {
      type: Boolean,
      default: true
    },

    searchPlaceholder: {
      type: String,
      default: 'Name, Category, Type, Sub-Type...'
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    // XOL-596 (completed steps): set when the table sits inside a request's step 2. The id is
    // that step's `action_steps.id`, sent with every equipment write so the API can refuse it
    // while the step is complete; `stepFrozen` is that step being complete now (the table
    // offers no Add and no delete, and the equipment drawer no Edit). A site page's table
    // passes neither and is unchanged.
    actionStepId: {
      type: Number,
      default: null
    },

    stepFrozen: {
      type: Boolean,
      default: false
    }

  },


  methods: {

    totalChanged (t) {
      this.totals = t
    },



    formatAssetName (row) {
      return '<b class="text-primary">' +
      (row.qty ? '</b>' + row.qty + ' x ' + row.category +
       (row.type ? ' / ' + row.type : '') +
       (row.subType ? ' / <b>' + row.subType + '</b>' : '') +
       (row.variant ? ' / ' + row.variant : '')
       : '')
    },



    formatBillable (isBill) {
      if (isBill) {
        return 'Billable'
      } else {
        return 'Free'
      }
    },

  },



  data () {
    return {
      totals: 0,
      icon: DEFAULT_ICON,
      qrCodeBtn: DEFAULT_MSG,
      zipFile: null,
      localData: this.siteData
    }
  },  // data

  computed: {

    // The equipment drawer's args: the asset id, and (inside a request's step 2) the step
    // context. A function is read from the row at click time, so `frozen` is the step as
    // it is when the row is opened.
    layerArgs () {
      var args = { id: 'id' }
      var self = this

      if (this.actionStepId) {
        args.actionStepId = function () { return self.actionStepId }
        args.frozen = function () { return self.stepFrozen ? 1 : 0 }
      }

      return args
    },

    // XOL-396: NOT plain data() — `visible` below reads isTowerCo() /
    // canAccess(), both of which resolve through profile() -> getStore(),
    // an async-hydrated store value. A data() snapshot would freeze
    // "not tower-co / no finance" as permanent if this component is
    // created before the profile bootstrap XHR resolves, which would
    // hide the Owner column forever for a TowerCo user on first paint.
    // See CLAUDE.md "Don't snapshot async-loaded store values in data()".
    //
    // Column widths measured live at http://localhost:8080/#/assets/d.siteEquip.555
    // (Equipment tab, dev server pre-migration, XOL-234 PR 8b): table width
    // 1195px. The `__sequence` (#) column is dropped entirely (explicit
    // instruction, also the accepted PR 8a precedent). With `#` removed, the
    // fixed columns at 1195px are: 70 (XolasTable's built-in chevron) + 99
    // (Owner) + 54 (controls) = 223px, leaving ~972px for the flex `assets`
    // column (was 957px measured with `#` present). Every fixed column also
    // carries a `minWidth` at the mandatory 0.7x scaled floor
    // (round(0.7 * measured), XolasTable.md "Scaled-minWidth convention")
    // so the table shrinks proportionally below the measurement viewport
    // instead of overflowing.
    //
    // XOL-396: for a non-tower-co caller both the chevron (layer-component
    // is null, so XolasTable never renders it) and the Owner column
    // (visible: isTowerCo() && (!ownerId || canAccess('finance')), false
    // here since isTowerCo() alone is false — see below) disappear, so the
    // fixed total collapses to 54px (controls only) and the flex `assets`
    // column grows to fill the rest. This now holds at every non-tower-co
    // mount regardless of whether owner-id happens to be bound (previously
    // it only held when ownerId was set, which SiteEquipView.vue:63 does
    // not do). TowerCo keeps the 223px total and the measurement above.
    fields () {
      return [
        {
          name: '__slot:shortName',
          title: 'Owner',
          // XOL-396: SiteEquipView.vue:63 mounts <equip-table> with no
          // owner-id binding, so ownerId falls back to its prop default
          // (null) and `!this.ownerId` alone is true for every org
          // category — the Owner column is TowerCo-only per the user
          // requirement, so isTowerCo() is required here, conjoined
          // (not substituted) with the existing ownerId/finance gate so
          // TowerCo behaviour at all other mounts is unchanged.
          visible: this.isTowerCo() && (!this.ownerId || this.canAccess('finance')),
          width: '99',
          minWidth: '69'
        },
        {
          name: '__slot:assets',
          title: '',
          minWidth: '670'
        },
        {
          // XOL-234: dropped a misspelled `visibla: isTowerCo()` key (typo
          // since 2020-11-25, never applied). Behaviour preserved — column
          // stays visible; the real gate is a separate follow-up.
          name: '__slot:equip-controls',
          title: '',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          width: '54',
          minWidth: '38',
          // XOL-596 (completed steps): a delete affordance is not rendered while the step is
          // complete (a disabled button's tooltip can't be reached).
          visible: !this.stepFrozen
        }
      ]
    }

  },

  created () {
    this.qrCodeInit(this.siteData, this.rowData, this.ownerId, this.siteId)
  }

}

</script>

<!-- Dev-parity: zero horizontal cell padding + tight line-height to match the
     legacy vuetable-2 render (dev <td> uses `12px 0`). -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
